/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Feb 02 2024
 **/

import styled from "@emotion/styled";

import { Column } from "@/frameworks/designStuff/components";
import { useProperties } from "@/frameworks/libraries/properties";

export default function ChatEmoticon(emoticon: ChatServices.Format2.Elements.Emoticon) {
	const properties = useProperties();
	return <Emoticon alt={emoticon.name} src={`${properties.default.webDomain}${emoticon.text}`} />;
}

const Emoticon = styled(Column)<{ src: string }>`
	width: 100px;
	height: 100px;
	background-image: url(${({ src }) => src});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
`;
